module.exports = __webpack_public_path__ + "img/LogoLoading_circle02.2184fbd2.png";